import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpHelperService {
  // Use HttpHeaders type to be fully compatible with HttpClient
  private options: { headers?: HttpHeaders | { [header: string]: string | string[] } } = {};

  constructor(private http: HttpClient) {}

  get<T>(path: string, options?: any): Observable<any> {
    return this.http.get<T>(path, { observe: 'response', ...this.options, ...(options || {}) });
  }

  post<T>(path: string, body: any, options?: any): Observable<any> {
    return this.http.post<T>(path, body, { observe: 'response', ...this.options, ...(options || {}) });
  }
}
